import React from 'react';
import clsx from 'clsx';

interface ComponentProps {
  icon: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}

// Figma "CO Button": a 32x32 bordered icon box (grey border, white bg, 4px radius). The caller
// supplies the (already-coloured) 16px icon.
const COButton: React.FC<ComponentProps> = ({ icon, onClick, disabled = false, className, dataTestId }) => {
  return (
    <button
      type={'button'}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
      className={clsx(
        'flex shrink-0 items-center justify-center w-8 h-8 rounded border border-solid border-content-tertiary bg-base-secondary disabled:opacity-50',
        className,
      )}>
      {icon}
    </button>
  );
};

export default COButton;
